import React from 'react'
import PropTypes from 'prop-types'
import { Block } from 'src/components'
import { mergeProps } from 'src/util'
import { Columns, Rows } from '../../layout'
import styles from './ModalBlock.scss'

/**
 * A modal-look-like-with-toolbar component that acts as a Block component.
 * If the content is too high for the screen, it will automatically scroll as a Block would do.
 */
const ModalBlock = ({ toolbar, ...props }) => (
  <Rows gap="1rem">
    <Block
      {...mergeProps({
        headerProps: mergeProps(),
        contentProps: mergeProps(),
      })(
        {
          className: styles.modal,
          headerProps: { className: styles.header },
          contentProps: { className: styles.content },
        },
        props
      )}
    />
    {!!toolbar && !props.loading && (
      <Columns layout="auto" justify="end">
        {toolbar}
      </Columns>
    )}
  </Rows>
)

ModalBlock.propTypes = {
  /**
   * Whether the block content is busy loading some content.
   */
  loading: PropTypes.bool,
  /**
   * The modal toolbar.
   */
  toolbar: PropTypes.node,
}

export default ModalBlock
